import { createSlice } from "@reduxjs/toolkit";
export const taskFilteredSlice = createSlice({
  name: "taskFilteredReducer",
  initialState: {
    currentPage: 1,
    filters: {
      startdate: "",
      enddate: "",
      status: "",
      assignTo: "",
      priority: "",
      upcomingTask: false,
      hideCompleted: false,
    },
  },
  reducers: {
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setReduxFilters: (state, action) => {
      state.filters = action.payload;
    },
  },
});

export const { setCurrentPage, setReduxFilters } = taskFilteredSlice.actions;
export default taskFilteredSlice.reducer;
